import type { FormSchemaEntry } from "@gik/ui-legacy/Form";

export const PhoneField = (): FormSchemaEntry => ({
	label: "Phone",
	name: "phone",
	type: "phone",
	required: true,
	minLength: 10,
	props: { maxLengthDisplay: false },
});
